import React from 'react'

import { Tooltip, RouterLinkTemplate } from 'Components'
import { addWebPToImageURL } from 'Helpers/utilities'

const StillCantFindlookingForCardBlock = ({ data, inEditMode }) => {
    const { Image, Heading, Subheading, Url, OpenLiveChat } = data
    const shouldOpenLiveChat = OpenLiveChat && !inEditMode

    const openLiveChat = () => {
        const launcherSelectors = [
            'div[aria-label="Chat with a Live Agent!"]',
            '.sm-reactive-tab'
        ]

        const clickLiveChatLauncher = () => {
            const launcherElement = launcherSelectors
                .map((selector) => document.querySelector(selector))
                .find((element) => element instanceof HTMLElement)

            if (launcherElement instanceof HTMLElement) {
                launcherElement.click()
                return true
            }

            return false
        }

        if (clickLiveChatLauncher()) {
            return
        }

        let currentAttemptCount = 0
        const maximumAttemptCount = 10
        const retryIntervalInMilliseconds = 300
        const retryTimerIdentifier = window.setInterval(() => {
            currentAttemptCount += 1

            if (clickLiveChatLauncher() || currentAttemptCount >= maximumAttemptCount) {
                window.clearInterval(retryTimerIdentifier)
            }
        }, retryIntervalInMilliseconds)
    }

    const cardContent = (
        <div className="shadow-normal cursor-pointer rounded-lg hover:shadow-active h-full grid content-between justify-items-center lg:p-4 sm:p-3 p-2">
            <div data-epi-edit="Image" className="lg:my-6 md:my-4 my-2">
                <img data-src={addWebPToImageURL(Image?.Url)} alt={Image?.AltTag} className="lazy hidden md:block" width="35" height="40" />
                <img data-src={addWebPToImageURL(Image?.Url)} alt={Image?.AltTag} className="lazy md:hidden" width="15" height="20" />
                {inEditMode && !Image && 'Click to edit Image'}
            </div>
            <h4 data-epi-edit="Heading"
                className="lg:text-lg md:text-base sm:text-sm text-xs font-semibold text-center">
                {Heading}
            </h4>
        </div>
    )

    return (
        <Tooltip tooltipText={Subheading}>
            {shouldOpenLiveChat
                ? (
                    <button type="button" onClick={openLiveChat} className="w-full h-full bg-transparent border-0 p-0 text-inherit text-left" aria-label={Heading}>
                        {cardContent}
                    </button>
                )
                : (
                    <RouterLinkTemplate Path={Url} inEditMode={inEditMode}>
                        {cardContent}
                    </RouterLinkTemplate>
                )}
        </Tooltip>
    )
}

export default React.memo(StillCantFindlookingForCardBlock)
